export const ADD_SUPPLIER_DETAILS = "ADD_SUPPLIER_DETAILS";
export const FETCH_SUPPLIER_DETAILS_LIST = "FETCH_SUPPLIER_DETAILS_LIST";
export const EDIT_SUPPLIER_DETAILS = "EDIT_SUPPLIER_DETAILS";
export const UPDATE_SUPPLIER_DETAILS = "UPDATE_SUPPLIER_DETAILS";
export const DELETE_SUPPLIER_DETAILS = "DELETE_SUPPLIER_DETAILS";
export const CLEAR_SUPPLIER_EDITED_DATA = "CLEAR_SUPPLIER_EDITED_DATA";
